import { getConfig } from '@bc/react-config';

export const getApiEndpoint = () => {
  return getConfig('REACT_APP_SAGA_API_ENDPOINT');
};

export const getProUrl = () => {
  return getConfig('REACT_APP_SAGA_PRO');
};
export const getSentryUrl = () => {
  return getConfig('REACT_APP_SAGA_SENTRY_URL');
};

export const getSentryEnvironment = () => {
  return getConfig('REACT_APP_SAGA_SENTRY_ENVIRONMENT');
};

export const getKeycloakUrl = () => {
  return getConfig('REACT_APP_SAGA_KEYCLOAK_URL');
};

export const getKeycloakRealm = () => {
  return getConfig('REACT_APP_SAGA_KEYCLOAK_REALM');
};

export const getKeycloakClientId = () => {
  return getConfig('REACT_APP_SAGA_KEYCLOAK_CLIENT_ID');
};

export const getMsgMaintenanceEn = () => {
  return getConfig('REACT_APP_MSGMAINTENANCEEN');
};
export const getMsgMaintenanceFr = () => {
  return getConfig('REACT_APP_MSGMAINTENANCEFR');
};
export const getMsgMaintenanceDateDebut = () => {
  return getConfig('REACT_APP_MSG_DATEDEBUT');
};
export const getMsgMaintenanceDateFin = () => {
  return getConfig('REACT_APP_MSG_DATEFIN');
};
export const getMaintenanceDateDebut = () => {
  return getConfig('REACT_APP_DATEDEBUT');
};
export const getMaintenanceDateFin = () => {
  return getConfig('REACT_APP_DATEFIN');
};

export const getCDNUrl = () => {
  return getConfig('REACT_APP_SAGA_CDN_URL');
};

export const getMatomoAnalyticsManager = () => {
  return getConfig('REACT_APP_SAGA_MATOMO') || '';
};

export const getAxeptioCookieManager = () => {
  return getConfig('REACT_APP_SAGA_AXEPTIO') || '';
};
